(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvToolBarButton', drvToolBarButton);

    drvToolBarButton.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvToolBarButton
     *
     * @description
     * Button intended for use in a drvToolBar
     *
     * # Scope Params
     * {String} icon - An optional icon for the button
     * {String} iconUsage - An optional icon usage for the button. E.g. 'document template', 'entity template'
     * {String} label - Optional label (tooltip) for the button
     * {Bool} showLabel - True to show the label text on the button
     * {Bool} isChecked - Indicate whether the button should use "checked" style, i.e. it's a check-button that is in the 'checked' state
     */
    function drvToolBarButton() {
        var directive = {
            restrict: 'E',
            scope: {
                icon: '@',
                iconUsage: '@',
                label: '@',
                showLabel: '@',
                isChecked: '<?'
            },
            template: '<button type="button" title="{{label}}" aria-label="{{label}}" ng-style="isChecked && {\'background-color\':\'#C0C0C0\'}"><drv-icon ng-if="icon.length || iconUsage.length" icon="icon" usage="iconUsage"></drv-icon><span ng-if="showLabel">{{label}}</span></button>'
        };
        return directive;
    }
})();